"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const LabeledFieldWidget_1 = tslib_1.__importDefault(require("./LabeledFieldWidget"));
const InputEventUtil_1 = tslib_1.__importDefault(require("../util/InputEventUtil"));
const KeyboardEventCodes_1 = require("../util/KeyboardEventCodes");
class LabeledInputFieldWidget extends LabeledFieldWidget_1.default {
    constructor(args) {
        super({ ...args, fieldType: "input" });
    }
    getFieldElement() {
        return super.getFieldElement();
    }
    /**
     * @deprecated Use getFieldElement() instead.
     */
    getInput() {
        return this.getFieldElement();
    }
    setPlaceholder(value) {
        super.setPlaceholder(value);
        if (!value) {
            this.fieldElement.removeAttribute("placeholder");
        }
        else {
            this.fieldElement.setAttribute("placeholder", value);
        }
    }
    addKeyDownListener(listener) {
        this.fieldElement.addEventListener("keydown", listener);
    }
    addBeforeInputListener(listener) {
        this.fieldElement.addEventListener("beforeinput", listener);
    }
    addOnInputListener(listener) {
        this.fieldElement.addEventListener("input", listener);
    }
    addKeyUpListener(listener) {
        this.fieldElement.addEventListener("keyup", listener);
    }
    addPasteListener(listener) {
        this.fieldElement.addEventListener("paste", listener);
    }
    focus() {
        this.fieldElement.focus();
    }
    blur() {
        this.fieldElement.blur();
    }
    /**
     *  Runs through all characters and checks if each character is a valid next character in sequence.
     * @param {string} value
     * @returns {boolean}
     */
    isValidInputString(value) {
        const chars = value.split("");
        let s = "";
        for (let char of chars) {
            if (!this.isValidNextChar(s, char, s.length, s.length)) {
                return false;
            }
            s += char;
        }
        return true;
    }
    simulateCharacterPressed(event) {
        if (!this.isEnabled()) {
            return;
        }
        if (!(0, KeyboardEventCodes_1.isTypeableCharacterEvent)(event)) {
            return;
        }
        const inputEvent = new InputEvent("insertText", { data: event.key });
        this.onBeforeInput(inputEvent);
        if (inputEvent.defaultPrevented) {
            return;
        }
        this.fieldElement.value = this.buildInsertTextString(event.key);
        this.hasUncommittedChanges = true;
        this.onInput(inputEvent);
        const cursorPos = this.fieldElement.value.length;
        this.fieldElement.setSelectionRange(cursorPos, cursorPos, "forward");
    }
    decorateLabeledFieldWidgetElement(args) {
        const { readOnly = false, inputType = "text" } = args;
        this.fieldElement.readOnly = readOnly;
        this.fieldElement.type = inputType;
        this.addOnFocusHandler(() => {
            this.fieldElement.select();
        });
        this.addBeforeInputListener(event => {
            this.onBeforeInput(event);
        });
        this.addOnInputListener(event => {
            this.onInput(event);
        });
        this.addPasteListener(event => {
            this.onPaste(event);
        });
        this.addOnBlurHandler(() => {
            this.onBlur();
        });
        this.fieldElement.addEventListener("change", () => {
            this.hasUncommittedChanges = false;
        });
        this.decorateLabeledInputFieldWidgetElement(args);
    }
    onBeforeInput(event) {
        const isValidInputEvent = this.isValidInputEvent(event);
        if (!isValidInputEvent) {
            return event.preventDefault();
        }
    }
    onInput(_event) {
        // format input value or whatever is needed.
    }
    onPaste(event) {
        const pasteString = this.buildPasteString(event);
        if (!this.isValidInputString(pasteString)) {
            return event.preventDefault();
        }
    }
    onBlur() {
        if (this.hasUncommittedChanges) {
            this.setValue(this.parseFieldElementValue(this.fieldElement.value), true);
        }
    }
    isValidNextChar(currentValue, char, selectionStart = null, selectionEnd = null) {
        return true;
    }
    isValidInputEvent(event) {
        if (!InputEventUtil_1.default.isInsertingText(event)) {
            return true;
        }
        const target = event.target;
        const currentValue = target.value ?? "";
        return this.isValidNextChar(currentValue, event.data, target.selectionStart, target.selectionEnd);
    }
    buildInsertTextString(insertText) {
        const currentValue = this.fieldElement.value ?? "";
        const selectionStart = this.fieldElement.selectionStart;
        const selectionEnd = this.fieldElement.selectionEnd;
        const start = currentValue.substring(0, selectionStart);
        const insertionTextTrimmed = insertText.trim();
        const end = currentValue.substring(selectionEnd, currentValue.length);
        return `${start}${insertionTextTrimmed}${end}`;
    }
    buildPasteString(event) {
        return this.buildInsertTextString(event.clipboardData.getData("text"));
    }
}
exports.default = LabeledInputFieldWidget;
//# sourceMappingURL=LabeledInputFieldWidget.js.map